import React from "react";
import "./Style.scss";
import { Container } from "react-bootstrap";
import FooterLinks from "./FooterContents/FooterLinks";
import AttentionInvestor from "./FooterContents/AttentionInvestor";
import UsefulLinks from "./FooterContents/UsefulLinks";
import CopyRight from "./FooterContents/CopyRight";
import CompanyDetails from "./FooterContents/CompanyDetails";

function Footer() {
  return (
    <>
      <section className="footerSectionContainer">
        <Container className="footerSection">
          <FooterLinks />
          <AttentionInvestor />
          <CompanyDetails />
          <UsefulLinks />
          <CopyRight />
        </Container>
      </section>
    </>
  );
}

export default Footer;
